export enum TextButtonTestIds {
	TextButtonElementTestId = 'sl-text-button',
	TextButtonLabelElementTestId = 'sl-text-button-label',
	TextButtonIconElementTestId = 'sl-text-button-icon',
}
